import { useState } from "react";
import { t } from "../i18n";
import { Link, useNavigate } from "react-router-dom";
import { api, errorMessage } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { AuthLayout } from "./Login";

export default function Registro() {
  const { loginSuccess } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", pin: "", pin2: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 8) return setError(t("auth.errPassword"));
    if (!/^\d{6}$/.test(form.pin)) return setError(t("auth.errPin"));
    if (form.pin !== form.pin2) return setError(t("auth.errPinMatch"));
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { email: form.email, password: form.password, pin: form.pin });
      loginSuccess(data);
      navigate("/bloqueo", { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally { setLoading(false); }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <AuthLayout title={t("auth.create")} subtitle={t("auth.registerSubtitle")}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div>
          <label className="label" htmlFor="r-email">{t("auth.email")}</label>
          <input id="r-email" data-testid="register-email-input" className="field" type="email" autoComplete="username" required value={form.email} onChange={set("email")} />
        </div>
        <div>
          <label className="label" htmlFor="r-password">{t("auth.passwordMin")}</label>
          <input id="r-password" data-testid="register-password-input" className="field" type="password" autoComplete="new-password" required value={form.password} onChange={set("password")} />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="label" htmlFor="r-pin">{t("auth.pin6")}</label>
            <input id="r-pin" data-testid="register-pin-input" className="field tracking-[0.4em]" inputMode="numeric" pattern="\d{6}" maxLength={6} type="password" required value={form.pin} onChange={set("pin")} />
          </div>
          <div>
            <label className="label" htmlFor="r-pin2">{t("auth.pinConfirm")}</label>
            <input id="r-pin2" data-testid="register-pin-confirm-input" className="field tracking-[0.4em]" inputMode="numeric" pattern="\d{6}" maxLength={6} type="password" required value={form.pin2} onChange={set("pin2")} />
          </div>
        </div>
        {error && <p data-testid="register-error" className="text-sm text-[#f43f5e]">{error}</p>}
        <button data-testid="register-submit-btn" className="btn-primary mt-2" disabled={loading}>{loading ? t("auth.creating") : t("auth.create")}</button>
      </form>
      <p className="text-sm text-muted-foreground mt-8">{t("auth.haveAccount")} <Link data-testid="go-login-link" className="text-[#f3c649]" to="/login">{t("auth.login")}</Link>
      </p>
    </AuthLayout>
  );
}
